import makeStateFilter from '../../../make-state-filter';

import { stateFilter as parentStateFilter } from '../../../store/reducer.metadata';

const namespace = 'scanToVerify';
const stateFilter = makeStateFilter(parentStateFilter, namespace);

export { namespace, stateFilter };
